import "./src/styles/tailwind.css"
import "@fortawesome/fontawesome-svg-core/styles.css"
